import { Col } from "antd";
import SectionOne from "../components/HomePageSections/SectionOne";
import SectionTwo from "../components/HomePageSections/SectionTwo";
import SectionThree from "../components/HomePageSections/SectionThree";

function HomePage() {
  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <SectionOne />
      <SectionTwo />
      <SectionThree />
    </Col>
  );
}

export default HomePage;
